export interface UserCredentials {
  email: string
  password: string
  rememberMe: boolean
  lastLogin: number
}

const CREDENTIALS_KEY = 'sparck_user_credentials'
const SESSION_KEY = 'sparck_session_data'

export const saveUserCredentials = (credentials: UserCredentials): void => {
  try {
    if (credentials.rememberMe) {
      localStorage.setItem(CREDENTIALS_KEY, JSON.stringify({
        email: credentials.email,
        rememberMe: true,
        lastLogin: Date.now()
      }))

      sessionStorage.setItem(SESSION_KEY, JSON.stringify({
        password: credentials.password,
        timestamp: Date.now()
      }))
    } else {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify({
        email: credentials.email,
        password: credentials.password,
        timestamp: Date.now()
      }))
    }
  } catch (error) {
    console.warn('Error saving credentials:', error)
  }
}

export const getUserCredentials = (): UserCredentials | null => {
  try {
    const sessionData = sessionStorage.getItem(SESSION_KEY)
    if (sessionData) {
      const parsed = JSON.parse(sessionData)
      const now = Date.now()

      if (now - parsed.timestamp < 24 * 60 * 60 * 1000) {
        return {
          email: parsed.email || '',
          password: parsed.password || '',
          rememberMe: false,
          lastLogin: parsed.timestamp
        }
      }
    }

    const storedData = localStorage.getItem(CREDENTIALS_KEY)
    if (storedData) {
      const parsed = JSON.parse(storedData)
      const now = Date.now()

      if (now - parsed.lastLogin < 30 * 24 * 60 * 60 * 1000) {
        return {
          email: parsed.email || '',
          password: '',
          rememberMe: true,
          lastLogin: parsed.lastLogin
        }
      }
    }

    return null
  } catch (error) {
    console.warn('Error getting credentials:', error)
    return null
  }
}

export const clearUserCredentials = (): void => {
  try {
    localStorage.removeItem(CREDENTIALS_KEY)
    sessionStorage.removeItem(SESSION_KEY)
  } catch (error) {
    console.warn('Error clearing credentials:', error)
  }
}

export const hasStoredCredentials = (): boolean => {
  return getUserCredentials() !== null
}

export const updateLastLogin = (): void => {
  try {
    const storedData = localStorage.getItem(CREDENTIALS_KEY)
    if (storedData) {
      const parsed = JSON.parse(storedData)
      parsed.lastLogin = Date.now()
      localStorage.setItem(CREDENTIALS_KEY, JSON.stringify(parsed))
    }
  } catch (error) {
    console.warn('Error updating last login:', error)
  }
}
